import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import WineList from './WineList';
import WineForm from './WineForm';

const WineRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<WineList />} />
      <Route path="/create" element={<WineForm />} />
      <Route path="/edit/:id" element={<WineForm />} />
      <Route path="*" element={<Navigate to="/admin/wines" replace />} />
    </Routes>
  );
};

export default WineRoutes;
